import { render } from "./ArrowCH.vue?vue&type=template&id=18bfbb96"
import script from "./ArrowCH.vue?vue&type=script&lang=js"
export * from "./ArrowCH.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__